import {OUTPUT_TYPE, LICENSE_TYPE} from '../constants/Type'
import * as AppUtil from './App'

/** ライセンスユーティリティ */

/**
 * 出力権限の確認
 * @param code
 */
export const checkLicense = (code) => {
  let user = AppUtil.getUserInfo()
  if (!user) return false
  let isDebug = user.menuServiceCode.tabMenuDebug
  let isTrial = LICENSE_TYPE.TRIAL === user.licenseType
  switch (code) {
    case OUTPUT_TYPE.OUTPUT_SH_PLAN.code:
      return user.menuServiceCode.outputShPlan
    case OUTPUT_TYPE.OUTPUT_SH_COMB.code:
      return user.menuServiceCode.outputShComb
    case OUTPUT_TYPE.OUTPUT_SH_UNIT.code:
      return user.menuServiceCode.outputShProcess
    case OUTPUT_TYPE.OUTPUT_SH_PROCESS.code:
      return user.menuServiceCode.outputShProcess
    case OUTPUT_TYPE.OUTPUT_NESTING_RUNNNING.code:
    case OUTPUT_TYPE.OUTPUT_NESTING_PANEL.code:
    case OUTPUT_TYPE.OUTPUT_NESTING_CUTDATA.code:
      return user.menuServiceCode.outputShNesting
    case OUTPUT_TYPE.OUTPUT_ESTIMATE.code:
      return user.menuServiceCode.outputEstimate
    case OUTPUT_TYPE.OUTPUT_MASTER_BOM.code:
      return user.menuServiceCode.outputBomMaster || isDebug || isTrial
    case OUTPUT_TYPE.OUTPUT_E_BOM.code:
      return user.menuServiceCode.outputBomDes
    case OUTPUT_TYPE.OUTPUT_CG.code:
      return user.menuServiceCode.outputCg
    case OUTPUT_TYPE.OUTPUT_PRESENTATION.code:
      return user.menuServiceCode.outputPresent
    case OUTPUT_TYPE.OUTPUT_PRODUCTION_PLAN.code:
      return user.menuServiceCode.outputProductionPlan
    case OUTPUT_TYPE.OUTPUT_MANUFACTURE_DOC.code:
      return user.menuServiceCode.outputManufactureDoc
    case OUTPUT_TYPE.OUTPUT_MATERIAL_LIST.code:
      return user.menuServiceCode.outputMaterialList
    case OUTPUT_TYPE.OUTPUT_PARTS_LABEL.code:
      return user.menuServiceCode.outputPartsLabel
    case OUTPUT_TYPE.OUTPUT_RISE.code:
      return user.menuServiceCode.outputLixil
    case OUTPUT_TYPE.OUTPUT_NC_DATA.code:
      return user.menuServiceCode.outputNcData
    default:
  }
  return false
}



// WEBPACK FOOTER //
// ./src/main/js/utils/License.js